import React, { useState } from 'react'
import './admin-functions.styles.scss'
import { UseCloudAdminFunction } from '../../../utils/firebase.utils'
import Modal from '../../modal/modal.component';

const AdminFunctions = () => {

  const [getCheckInId, setGetCheckInId] = useState(false);

  async function runAdminFunction(command, data) {
    console.log(`Running admin function: ${command}`)
    const res = await UseCloudAdminFunction(command, data)
    console.log(res);
  }

  async function getCheckInData() {
    const evalId = document.getElementById('evalId').value;
    const res = await UseCloudAdminFunction('getCheckInData', {'evalId': evalId});
    console.log(res);

    const data = res.checkInData;
    if (!data || !data.length) return;

    const headers = Object.keys(data[data.length - 1]);
    const rows = data.map(obj =>
      headers.map(h => {
        let val = obj[h] ?? '';
        if (h === 'ts' && val) {
          val = new Date(val).toLocaleString('en-US', { timeZone: 'America/Chicago' });
        }
        return `"${String(val).replace(/"/g, '""')}"`;
      }).join(',')
    );

    const csv = [headers.join(','), ...rows].join('\n');
    const blob = new Blob([csv], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `checkIn_${evalId}.csv`;
    a.click();
    URL.revokeObjectURL(url);
    setGetCheckInId(false);
  }

  return (
    <div className="admin-functions">
      <div className='g-card functions-content'>
        <h3>Admin Functions</h3>
        <hr />
        <div className='admin-buttons'>
          {/* <button className='g-button' onClick={() => runAdminFunction(
            'moveEvalsToFirestore', 
            {'data': 'some data'}
          )}>
            Move Evaluations to Firestore
          </button>
          <button className='g-button' onClick={() => runAdminFunction(
            'moveCompletedEvalsToFirestore', 
            {'data': 'some data'}
          )}>
            Move All Completed Evaluations to Firestore
          </button>
          <button className='g-button' onClick={() => runAdminFunction(
            'moveSelectedEvalsToFirestore', 
            {'cstKey': '60525e48-283c-4ed3-b647-788d5f0aeac8'}
          )}>
            Move Select Completed Evaluations to Firestore
          </button> */}
          <button className='g-button disabled' onClick={() => runAdminFunction(
            'refactorEvaluations',
            {
              
            }
          )}>
            Refactor Evaluations
          </button>
          <button className='g-button ' onClick={() => runAdminFunction(
            'refactorQuestionSets',
            {}
          )}>
            Refactor Question Sets
          </button>
          <button className='g-button' onClick={() => runAdminFunction(
            'refactorEvalList',
            {}
          )}>
            Refactor Eval List
          </button>
          <button className='g-button' onClick={() => setGetCheckInId(true)}>
            Get Check-In Data
          </button>
        </div>
      </div>
      <Modal 
        show={getCheckInId} 
        cancel={() => setGetCheckInId(false)}
        text="Get Check-In Data" >
        <div className='admin-modal-content'>
          <div className='field'>
            <label>Enter Eval ID</label>
            <input 
            className='uk-input'
              type="text"
              id="evalId" />
          </div>
          <div className="g-space-1"></div>
          <div className='buttons'>
            <button 
              className='g-button' 
              onClick={() => getCheckInData()}>
              Get Check-In Data
            </button>
          </div>
        </div>
      </Modal>
    </div>
  )
}

export default AdminFunctions